<template>
  <AppCard flat class="metric-card pa-3" :height="height">
    <div class="metric-wrapper">
      <div class="metric-content">
        <div class="metric-value" :style="{ color: resolvedColor }">
          {{ value }}
        </div>

        <div class="metric-label" :style="{ color: resolvedColor }">
          {{ label }}
        </div>
      </div>

      <v-progress-circular v-if="showProgress" :value="safeProgressValue" :color="textColor" :size="48" :width="5">
        <span class="metric-progress" :style="{ color: resolvedColor }"> {{ formattedProgress }}% </span>
      </v-progress-circular>
    </div>
  </AppCard>
</template>

<script>
export default {
  name: 'AppMetricCard',

  props: {
    value: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },

    textColor: {
      type: String,
      default: 'primary',
    },

    showProgress: {
      type: Boolean,
      default: false,
    },

    progressValue: {
      type: Number,
      default: 0,
    },

    height: {
      type: [Number, String],
      default: 96,
    },
  },

  computed: {
    safeProgressValue() {
      return Number(this.progressValue || 0)
    },

    formattedProgress() {
      return this.safeProgressValue.toFixed(0)
    },

    resolvedColor() {
      const colors = {
        primary: '#1976D2',
        success: '#4CAF50',
        warning: '#FB8C00',
        error: '#EF5350',
        black: '#222222',
      }

      return colors[this.textColor] || '#222222'
    },
  },
}
</script>

<style scoped>
.metric-card {
  border-radius: 10px;
}

.metric-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  gap: 12px;
}

.metric-content {
  min-width: 0;
}

.metric-value {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

.metric-label {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.metric-progress {
  font-size: 11px;
  font-weight: 700;
}
</style>
